module.exports = __webpack_public_path__ + "static/itsalive-cover-7dc477fe5981250a0cb4970695af5652.png";